import { ProGalleriesSmall } from '@wix/wix-ui-icons-common';

import {
  type EditorPluginCreator,
  quickActionsModalSections,
  RicosPluginToolbarNames,
} from './../ricos-types';
import { changeSelectionToEndOfTextBlock } from './../wix-rich-content-common';

import { DEFAULTS } from './defaults';
import { galleryConverter } from './gallery-converter';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { handleGalleryUpload } from './handle-gallery-upload';
import { GallerySettingsModal } from './modals/settings';
import { tiptapExtensions } from './tiptap/tiptap';
import { LayoutDropdown } from './toolbar/LayoutDropdown';
import type { GalleryPluginEditorConfig } from './types';
import { GALLERY_TYPE } from './types';

export const pluginGallery: EditorPluginCreator<
  GalleryPluginEditorConfig,
  {
    SettingsModal: typeof GallerySettingsModal;
    LayoutDropdown: typeof LayoutDropdown;
  }
> = config => {
  const pluginConfig: GalleryPluginEditorConfig = { ...DEFAULTS.containerData, ...config };
  return {
    config: pluginConfig,
    type: GALLERY_TYPE,
    pmMarkConverters: [],
    pmNodeConverters: [galleryConverter],
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.GALLERY],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    getQuickActions: ({ pluginServices, config }) => [
      {
        id: 'gallery',
        title: 'QuickActionsPlugin_ActionTitle_Gallery',
        icon: ProGalleriesSmall,
        section: quickActionsModalSections.Media,
        tags: ['gallery', 'photo', 'album', 'picture', 'collection', 'slideshow', 'portfolio'],
        command: ({ publicCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          handleGalleryUpload({ publicCommands, services: pluginServices, config });
        },
      },
    ],
    __exports: {
      SettingsModal: GallerySettingsModal,
      LayoutDropdown,
    },
  };
};
